<template>
  <div class="migration-data">
    <!-- .is-selected y no .active: _base-modal.vue fuerza .active a display: block -->
    <div class="segmented" role="tablist">
      <button
        type="button"
        role="tab"
        :class="{ 'is-selected': side === 'data' }"
        :aria-selected="side === 'data' ? 'true' : 'false'"
        @click="side = 'data'"
      >
        Data
        <span class="count">{{ dataList.length }}</span>
      </button>
      <button
        type="button"
        role="tab"
        :class="{ 'is-selected': side === 'logs' }"
        :aria-selected="side === 'logs' ? 'true' : 'false'"
        @click="side = 'logs'"
      >
        Logs
        <span class="count">{{ logList.length }}</span>
      </button>
    </div>

    <div v-if="side === 'data'">
      <div v-if="dataList.length === 0" class="empty-state">
        <i class="mdi mdi-sync-off"></i>
        <p>This order has not been sent to Infoauto yet.</p>
      </div>
      <div v-else class="table-scroll">
        <table class="default-table">
          <thead>
            <tr>
              <th>Date</th>
              <th>Document Id</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in dataList" :key="item.id">
              <td class="whitespace-nowrap">{{ item.createdAt }}</td>
              <td>
                <span class="mono">{{ item.infoautoId }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div v-if="side === 'logs'">
      <div v-if="logList.length === 0" class="empty-state">
        <i class="mdi mdi-file-search-outline"></i>
        <p>No Infoauto logs yet.</p>
      </div>
      <div v-for="item in logList" :key="item.id" class="log-card">
        <div class="log-head">
          <span>{{ item.createdAt }}</span>
          <span class="doc" :class="{ 'is-missing': !item.infoautoId }">
            {{ item.infoautoId || "No document" }}
          </span>
        </div>
        <div class="log-label">Params</div>
        <pre class="log-body">{{ item.params }}</pre>
        <div class="log-label">Response</div>
        <pre class="log-body">{{ item.response }}</pre>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "InfoautoOrderMigrationData",
  props: {
    infoautoData: {
      type: Array,
      required: true
    },
    infoautoDataLogs: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      side: "data"
    };
  },
  computed: {
    // El modal puede pasar undefined si la orden nunca se migro
    dataList() {
      return this.infoautoData || [];
    },
    logList() {
      return this.infoautoDataLogs || [];
    }
  },
  methods: {}
};
</script>
<style lang="scss" scoped>
.migration-data {
  padding: 12px 14px;
}

.segmented {
  display: inline-flex;
  gap: 2px;
  margin-bottom: 12px;
  padding: 3px;
  border-radius: 10px;
  background: #f3f4f6;

  button {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    height: 32px;
    padding: 0 12px;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 500;
    color: #4b5563;

    &.is-selected {
      background: white;
      font-weight: 600;
      color: #126e6a;
      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.12);
    }
  }

  .count {
    min-width: 22px;
    padding: 0 5px;
    border-radius: 999px;
    background: rgba(0, 0, 0, 0.06);
    font-size: 16px;
    line-height: 22px;
    text-align: center;
  }
}

.table-scroll {
  overflow-x: auto;
}

.mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 16px;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 1.5rem 1rem;
  color: #6b7280;

  i {
    font-size: 2.25rem;
    color: #d1d5db;
  }

  p {
    margin: 0;
    font-size: 16px;
  }
}

.log-card {
  margin-bottom: 8px;
  padding: 10px 12px;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  background: #f9fafb;
}

.log-head {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 4px 12px;
  margin-bottom: 6px;
  font-size: 16px;
  font-weight: 600;
  color: #374151;

  .doc {
    color: #15803d;

    &.is-missing {
      color: #b45309;
    }
  }
}

.log-label {
  margin-top: 6px;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #6b7280;
}

.log-body {
  max-height: 180px;
  margin: 2px 0 0;
  padding: 8px;
  overflow: auto;
  border-radius: 6px;
  background: white;
  font-size: 16px;
  white-space: pre-wrap;
  word-break: break-word;
  color: #111827;
}
</style>
